import React from 'react';

interface SecIconProps {
  height?: number;
  className?: string;
}

export const SecLogo: React.FC<SecIconProps> = ({ height = 26, className }) => {
  return (
    <svg
      height={height}
      width={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="32" height="32" rx="4" fill="#003D7A" />
      <path
        d="M6 24C6 24.5523 6.44772 25 7 25C7.55228 25 8 24.5523 8 24V18C8 17.4477 7.55228 17 7 17C6.44772 17 6 17.4477 6 18V24Z"
        fill="white"
      />
      <path
        d="M11 24C11 24.5523 11.4477 25 12 25C12.5523 25 13 24.5523 13 24V14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V24Z"
        fill="white"
      />
      <path
        d="M16 24C16 24.5523 16.4477 25 17 25C17.5523 25 18 24.5523 18 24V11C18 10.4477 17.5523 10 17 10C16.4477 10 16 10.4477 16 11V24Z"
        fill="white"
      />
      <path
        d="M21 24C21 24.5523 21.4477 25 22 25C22.5523 25 23 24.5523 23 24V8C23 7.44772 22.5523 7 22 7C21.4477 7 21 7.44772 21 8V24Z"
        fill="white"
      />
      <path
        d="M24.7071 8.29289C24.3166 7.90237 23.6834 7.90237 23.2929 8.29289L22 9.58579L20.7071 8.29289C20.3166 7.90237 19.6834 7.90237 19.2929 8.29289C18.9024 8.68342 18.9024 9.31658 19.2929 9.70711L21.2929 11.7071C21.6834 12.0976 22.3166 12.0976 22.7071 11.7071L24.7071 9.70711C25.0976 9.31658 25.0976 8.68342 24.7071 8.29289Z"
        fill="#4ADE80"
      />
    </svg>
  );
};
